import { Injectable, OnDestroy } from '@angular/core';
import { AppLoadingService } from '../../services/apploading.service';
import { HttpService } from 'src/app/core/http/http.service';
import { API } from 'src/app/configs';
import { GeneralService } from '../../services/general.service';
import { PersonService } from '../../services/person.service';
import { Person } from '../../models/person';
import { Subscription } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PostsService implements OnDestroy{


    postStatus = [
        {id : 2, name : 'Publicado'},
        {id : 1, name : 'Rascunho'},
        {id : -5, name : 'Excluído', hide : true},
    ];


    postTypes = [];

    person: Person = new Person();
    person_id: any;

   
    companieSelData: any = {};
    protected companieSelSubscription: Subscription;

    constructor(
        protected als: AppLoadingService,
        protected httpService: HttpService,
        protected gs: GeneralService,
        protected personService : PersonService
    ){
        this.companieSelSubscription = this.gs.companiesSel$.subscribe(async result => {
            this.companieSelData = this.gs.getCompanieData(result);
            this.loadPersonData();
        });

    }

    ngOnDestroy(): void {
        this.companieSelSubscription?.unsubscribe();
    }


    async save(data, site_public_idtext){
        await this.als.setLoaded(false,'savePost');

        return await this.httpService.post<any>(API.site.general.post.base,{
            "site_public_idtext":site_public_idtext,
            "owner_public_idtext":this.companieSelData.company_public_idtext,
            ...data
        }).then(result => {
            this.gs.message('Post salvo com sucesso');
            return {id : result};
        })
        .catch(err => this.gs.error(err))
        .finally(() => {
            this.als.setLoaded(true,'savePost');
        });
    }

    async update(data){
        await this.als.setLoaded(false,'savePost');

        return await this.httpService.put<any>(API.site.general.post.base,{
            "owner_public_idtext":this.companieSelData.company_public_idtext,
            ...data
        }).then(result => {
            this.gs.message('Post salvo com sucesso');
            return {id : result};
        })
        .catch(err => this.gs.error(err))
        .finally(() => {
            this.als.setLoaded(true,'savePost');
        });
    }

    async delete(id){ 
        return await this.update({
            "public_idtext" : id,
            "status" : -5
        });
    }

    async listPosts(site_public_idtext:string, pageSize: number, pageIndex: number){
        await this.als.setLoaded(false,'loadPost');
        return await this.httpService.post<any>(API.site.general.post.list,{
            "site_public_idtext":site_public_idtext,
            "owner_public_idtext":this.companieSelData.company_public_idtext,
            "total_rows":pageSize,
            "current_page":pageIndex
        }).then(result => {
            return result;
        })
        .catch(err => this.gs.error(err))
        .finally(() => {
            this.als.setLoaded(true,'loadPost');
        });
    }
    
    async loadPost(id){
        await this.als.setLoaded(false,'loadPost');
        return await this.httpService.post<any>(API.site.general.post.view,{
            "owner_public_idtext":this.companieSelData.company_public_idtext,
            "public_idtext" : id
        }).then(result => {
            return result;
        })
        .catch(err => this.gs.error(err))
        .finally(() => {
            this.als.setLoaded(true,'loadPost');
        });
    }

    async typesList(){
        await this.als.setLoaded(false,'typesList');
        
        this.httpService.post<any>(API.site.general.post.typeList, {})
        .then(result => {
            this.postTypes = result;
        })
        .catch((err) => {  
            this.gs.error(err); 
        })
        .finally(() => {
            this.als.setLoaded(true,'typesList');
        });
    }

    async loadPersonData() {
        return null;
        if(this.companieSelData?.company_person_id)
        return await this.personService
          .loadCompany(this.companieSelData.company_person_id)
          .then((result) => {
            this.person = result;
            this.person_id = this.person.id;
          })
          .catch((err) => { this.gs.error(err); });
    
      }



}